import dayjs from "dayjs";

export const resolveDateRangeParams = ({
  queryString,
  isQueryString = true,
  allTime = false,
}) => {
  if (isQueryString && typeof queryString === "string") {
    const [start, end] = queryString.split("&");
    return {
      startDate: dayjs(start).format("YYYY-MM-DD"),
      endDate: dayjs(end).format("YYYY-MM-DD"),
    };
  }

  if (allTime) {
    return {
      startDate: null,
      endDate: null,
    };
  }

  return {
    startDate: queryString?.[0]?.format("YYYY-MM-DD"),
    endDate: queryString?.[1]?.format("YYYY-MM-DD"),
  };
};

export const toQueryString = (
  params = {},
  { includeQuestionMark = true, includeEmpty = false } = {}
) => {
  const query = Object.entries(params)
    .filter(([, value]) => {
      if (value === null || value === undefined) {
        return false;
      }

      if (!includeEmpty && value === "") {
        return false;
      }

      return true;
    })
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join("&");

  if (!query) {
    return "";
  }

  return includeQuestionMark ? `?${query}` : query;
};

export const resolveServerSorter = (sorter) => {
  const normalizedSorter = Array.isArray(sorter)
    ? sorter.find((item) => item?.order) || sorter[0]
    : sorter;
  const sorterField = normalizedSorter?.field || normalizedSorter?.columnKey || null;

  if (normalizedSorter?.order === "ascend") {
    return {
      sortBy: sorterField,
      sortOrder: "asc",
    };
  }

  if (normalizedSorter?.order === "descend") {
    return {
      sortBy: sorterField,
      sortOrder: "desc",
    };
  }

  return {
    sortBy: null,
    sortOrder: null,
  };
};
